import React from 'react'
import styled from 'styled-components'
import { Flex } from 'ui/acro'
import Text from 'ui/acro/typography/Text'
import SignUp from 'components_v2/Subscribe/Signup/Aloaccess/SignUp'
import { sign_up_initiated_event } from 'gtm/pushEvents'
import AloVerifySection from 'components_v2/CommonComponents/AloVerifySection'

const Container = styled(Flex)({
  gap: '24px',
  flexDirection: 'column',
  marginTop: '12px'
})

const Section = styled(Flex)(({ isSettingsPage }) => ({
  flexDirection: 'column',
  gap: '8px',
  alignItems: isSettingsPage ? 'flex-start' : 'center'
}))

const Title = styled(Text)({
  color: '#000',
  fontFamily: 'Proxima-Nova',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '24px',
  letterSpacing: '0.352px'
})

const LinkContainer = styled('div')({
  color: '#000',
  fontFamily: 'Proxima-Nova',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '18px',
  letterSpacing: '0.308px',
  gap: '4px',
  '& b': {
    whiteSpace: 'nowrap'
  }
})

const Link = styled('a')(({ isSettingsPage }) => ({
  color: '#000',
  fontFamily: 'Proxima-Nova',
  fontSize: '14px',
  fontWeight: isSettingsPage ? 600 : 400,
  lineHeight: '18px',
  letterSpacing: '0.308px',
  textDecoration: 'underline !important',
  '&:visited': {
    color: '#000',
    textDecoration: 'underline !important'
  }
}))

const AloSignupAndVerifyLinks = ({
  showSignup,
  setShowSignup,
  setCustomerEmail,
  verifyCallbackUrl = '',
  signUpCallbackUrl = '',
  location = 'sign_in',
  setSubmitData = () => {},
  isSettingsPage = false
}) => {
  const verifyLink = verifyCallbackUrl
    ? `/verify-alo?redirect_to=${encodeURIComponent(verifyCallbackUrl)}`
    : '/verify-alo'

  return (
    <Container>
      <Section isSettingsPage={isSettingsPage}>
        <Title>
          {isSettingsPage ? (
            <>
              <b>New </b> to ALO Access?
            </>
          ) : (
            <>Don't have an account?</>
          )}
        </Title>
        <LinkContainer>
          <Link
            isSettingsPage={isSettingsPage}
            onClick={() => {
              sign_up_initiated_event('email', location)
              setShowSignup(true)
            }}
          >
            {isSettingsPage ? 'Join & Link Account' : 'Join Now'}
          </Link>{' '}
          {/* {isSettingsPage ? (
            <span>
              using the <b>same email</b> you use for your club account.
            </span>
          ) : (
            ''
          )} */}
        </LinkContainer>
      </Section>

      {location !== 'sign_in' && (
        <AloVerifySection
          isSettingsPage={isSettingsPage}
          verifyLink={verifyLink}
          event={location}
        />
      )}
      {/* signup modal */}
      <SignUp
        show={showSignup}
        setVisibility={setShowSignup}
        setCustomerEmail={setCustomerEmail}
        signUpCallbackUrl={signUpCallbackUrl}
        isSettingsPage={isSettingsPage}
        setSubmitData={setSubmitData}
        verifyLink={verifyLink}
      />
    </Container>
  )
}

export default AloSignupAndVerifyLinks
